/*
 * Scratch popup behaviour. DRAFT, not pushed. Spec: docs/scratch-popup-spec.md.
 *
 * Two variants, 'a' (mystisk rabatt) and 'b' (Black Month), picked 50/50 the first time the popup is due and then
 * remembered, so a visitor always sees the same one. The variant goes to Klaviyo as profile property `variant`
 * and in `kilde` (popup-scratch-a / popup-scratch-b), so sign-ups can be compared per variant.
 *
 * Wheel mode: every slice is a prize that can really be won; the spin picks a prize by weight (data-weights) and the
 * won prize goes to Klaviyo as profile property `premie`. Never list a prize that cannot be won.
 *
 * Same rules as the guide popup: shows after a delay and only when the cookie banner is out of the way, never on
 * checkout, cart, contact or account, closed = quiet for data-hold-days, signed up = never again, posts straight
 * to Klaviyo's client subscriptions API (no klaviyo.js, no cookie). All IDs come from data attributes.
 *
 * Testing: ?ksp=a or ?ksp=b opens that variant at once, ignoring the delay and everything stored.
 * data-preview on the root turns the network call off (used for the static preview only).
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  /* Klaviyo API revision. Bump deliberately; the request shape below is tied to it. */
  var REVISION = '2024-10-15';
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var STORE_KEY = 'kardimaScratchPopup';
  var VARIANT_KEY = 'kardimaScratchVariant';
  var BLOCKED_PATHS = ['/checkout', '/cart', '/pages/kontakt', '/account'];
  var DAY = 86400000;
  /* Scratch values, see the spec: brush radius in CSS px, share of cleared pixels that reveals the prize. */
  var BRUSH = 36;
  var REVEAL_AT = 0.5;

  var root = document.querySelector('[data-ksp]');
  if (!root) return;

  var company = root.getAttribute('data-company') || '';
  var list = root.getAttribute('data-list') || '';
  var delay = parseInt(root.getAttribute('data-delay'), 10) || 8000;
  var holdDays = parseInt(root.getAttribute('data-hold-days'), 10) || 30;
  var preview = root.hasAttribute('data-preview');
  /* Wheel mode: set data-variant-fixed (one variant, no A/B) and data-kilde (source tag for Klaviyo). */
  var fixed = root.getAttribute('data-variant-fixed') || '';
  var kildeAttr = root.getAttribute('data-kilde') || '';

  var card = root.querySelector('[data-ksp-card]');
  var cover = root.querySelector('[data-ksp-cover]');
  var claim = root.querySelector('[data-ksp-claim]');
  var form = root.querySelector('[data-ksp-form]');
  var input = form ? form.querySelector('input[type="email"]') : null;
  var submit = form ? form.querySelector('button[type="submit"]') : null;
  var status = form ? form.querySelector('[data-ksp-status]') : null;
  var live = root.querySelector('[data-ksp-live]');
  var wheel = root.querySelector('[data-ksp-wheel]');
  var mainBtn = root.querySelector('[data-ksp-main]');
  var subEl = root.querySelector('[data-ksp-sub]');
  var variant = 'a';
  var revealed = false;
  var lastFocus = null;

  /* ---------- storage ---------- */

  function read(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || 'null');
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* private mode or blocked storage: the popup simply may show again next visit */
    }
  }

  function suppressed() {
    var s = read(STORE_KEY);
    if (!s) return false;
    if (s.done) return true;
    return typeof s.until === 'number' && Date.now() < s.until;
  }

  function onBlockedPage() {
    var path = window.location.pathname;
    for (var i = 0; i < BLOCKED_PATHS.length; i += 1) {
      if (path.indexOf(BLOCKED_PATHS[i]) === 0) return true;
    }
    return false;
  }

  function bannerOpen() {
    var banner = document.getElementById('KardimaCookieBanner');
    return !!banner && !banner.hidden;
  }

  /* ---------- variant ---------- */

  function pickVariant() {
    if (fixed) return fixed;
    var m = window.location.search.match(/[?&]ksp=([ab])\b/);
    if (m) return m[1];
    var stored = read(VARIANT_KEY);
    if (stored === 'a' || stored === 'b') return stored;
    var chosen = Math.random() < 0.5 ? 'a' : 'b';
    write(VARIANT_KEY, chosen);
    return chosen;
  }

  function applyVariant() {
    root.setAttribute('data-variant', variant);
    var picture = root.querySelector('[data-ksp-picture]');
    var url = picture ? picture.getAttribute('data-bg-' + variant) : '';
    if (picture && url) picture.style.backgroundImage = 'url("' + url + '")';
  }

  /* ---------- steps ---------- */

  function showStep(name) {
    var steps = root.querySelectorAll('[data-ksp-step]');
    for (var i = 0; i < steps.length; i += 1) {
      steps[i].hidden = steps[i].getAttribute('data-ksp-step') !== name;
    }
  }

  function say(kind, text) {
    if (!status) return;
    status.textContent = text || '';
    status.setAttribute('data-kind', kind);
    status.hidden = !text;
  }

  /* ---------- measurement ---------- */
  /* Sends popup_view / popup_submit to whatever is loaded: Klaviyo onsite (only present after consent),
   * GA4 gtag, and Shopify customer events. Each call is guarded, so a missing or blocked tool is skipped.
   * Not fired in preview mode or on ?ksp= test links. Added 2026-11-03. */
  var viewSent = false;
  function measure(name, extra) {
    if (preview || /[?&]ksp=/.test(window.location.search)) return;
    var props = { popup: 'scratch', variant: kildeAttr ? 'wheel' : variant, kilde: kildeAttr || ('popup-scratch-' + variant), page: window.location.pathname };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
    var klaviyoName = name === 'popup_view' ? 'Viewed Scratch Popup' : 'Submitted Scratch Popup';
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['track', klaviyoName, props]);
      else if (window._learnq && typeof window._learnq.push === 'function') window._learnq.push(['track', klaviyoName, props]);
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, props);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, props);
      }
    } catch (e) {}
  }

  function open() {
    if (!root.hidden) return;
    lastFocus = document.activeElement;
    applyVariant();
    revealed = false;
    if (cover) cover.classList.remove('is-done');
    if (claim) claim.classList.remove('is-shown');
    if (wheel) resetWheel();
    showStep('scratch');
    root.hidden = false;
    window.requestAnimationFrame(wheel ? function () { paintWheel(0); } : paintCover);
    if (wheel && mainBtn) mainBtn.focus({ preventScroll: true });
    else if (card) card.focus({ preventScroll: true });
    if (!viewSent) {
      viewSent = true;
      measure('popup_view');
    }
  }

  function close(remember) {
    root.hidden = true;
    if (remember) write(STORE_KEY, { until: Date.now() + holdDays * DAY });
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    var items = root.querySelectorAll('button, a[href], input, [data-ksp-card]');
    var visible = [];
    for (var i = 0; i < items.length; i += 1) {
      if (items[i].offsetParent !== null && !items[i].disabled && !items[i].closest('[hidden]')) visible.push(items[i]);
    }
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------- scratch card ---------- */

  var ctx = null;
  var size = 0;
  var dpr = 1;

  function paintCover() {
    if (!cover || !card) return;
    size = card.clientWidth;
    if (!size) return;
    dpr = Math.max(1, window.devicePixelRatio || 1);
    cover.width = Math.round(size * dpr);
    cover.height = Math.round(size * dpr);
    ctx = cover.getContext('2d', { alpha: true });
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';

    var emerald = getComputedStyle(root).getPropertyValue('--kardima-emerald').trim() || '#295442';
    var deep = getComputedStyle(root).getPropertyValue('--kardima-emerald-deep').trim() || '#1b3b30';
    var gold = getComputedStyle(root).getPropertyValue('--kardima-gold').trim() || '#c9a65c';
    var family = getComputedStyle(root.querySelector('.ksp__title')).fontFamily || 'serif';

    var g = ctx.createLinearGradient(0, 0, size, size);
    g.addColorStop(0, emerald);
    g.addColorStop(1, deep);
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, size, size);

    ctx.strokeStyle = gold;
    ctx.globalAlpha = 0.55;
    ctx.lineWidth = 1;
    ctx.strokeRect(size * 0.04, size * 0.04, size * 0.92, size * 0.92);
    ctx.globalAlpha = 1;

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = 'rgba(247, 244, 237, 0.4)';
    ctx.font = 'italic 300 ' + Math.round(size * 0.115) + 'px ' + family;
    ctx.fillText('skrap', size / 2, size * 0.3);
    ctx.fillText('her', size / 2, size * 0.7);
    var logo = coverLogo(gold);
    if (logo.complete && logo.naturalWidth) {
      var lw = size * 0.58;
      var lh = lw / 3; /* the wordmark's viewBox is 1125 x 375 */
      ctx.drawImage(logo, (size - lw) / 2, (size - lh) / 2, lw, lh);
    }
  }

  /* The real wordmark (snippets/kardima-logo.liquid), recoloured gold, as an image the canvas can draw. */
  var logoImg = null;
  function coverLogo(gold) {
    if (logoImg) return logoImg;
    logoImg = new Image();
    var svg = root.querySelector('.ksp__logo svg');
    if (!svg) return logoImg;
    var clone = svg.cloneNode(true);
    clone.setAttribute('width', '1125');
    clone.setAttribute('height', '375');
    var markup = new XMLSerializer().serializeToString(clone).replace(/#ffffff/gi, gold);
    logoImg.onload = function () {
      if (!revealed && !clearedShare()) paintCover();
    };
    logoImg.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markup);
    return logoImg;
  }

  function clearedShare() {
    if (!ctx) return 0;
    var data = ctx.getImageData(0, 0, cover.width, cover.height).data;
    var step = 16; /* sample one pixel in 16 for speed; plenty for a share */
    var cleared = 0;
    var total = 0;
    for (var i = 3; i < data.length; i += 4 * step) {
      total += 1;
      /* Each brush dot only removes part of the cover (the fill is semi-transparent), so a finger stroke leaves
         faint residue. Count a pixel as scratched once it is mostly see-through, not only when it is exactly 0. */
      if (data[i] < 64) cleared += 1;
    }
    return total ? cleared / total : 0;
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    cover.classList.add('is-done');
    if (claim) claim.classList.add('is-shown');
    if (live) {
      var prize = root.querySelector('[data-ksp-prize]');
      live.textContent = prize ? prize.innerText.replace(/\s+/g, ' ').trim() : '';
    }
  }

  var pending = false;
  function check() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      if (!revealed && clearedShare() >= REVEAL_AT) reveal();
      pending = false;
    });
  }

  function point(event) {
    var r = cover.getBoundingClientRect();
    return { x: event.clientX - r.left, y: event.clientY - r.top };
  }

  function dot(x, y) {
    ctx.beginPath();
    ctx.arc(x, y, BRUSH, 0, Math.PI * 2);
    ctx.fill();
  }

  function stroke(x0, y0, x1, y1) {
    var dx = x1 - x0;
    var dy = y1 - y0;
    var dist = Math.hypot(dx, dy);
    var gap = Math.max(1, BRUSH * 0.4);
    var n = Math.ceil(dist / gap);
    for (var i = 1; i <= n; i += 1) {
      dot(x0 + (dx * i) / n, y0 + (dy * i) / n);
    }
  }

  var down = false;
  var lastX = 0;
  var lastY = 0;

  if (cover) {
    cover.addEventListener('pointerdown', function (event) {
      if (!ctx) return;
      event.preventDefault();
      if (cover.setPointerCapture) cover.setPointerCapture(event.pointerId);
      var p = point(event);
      ctx.globalCompositeOperation = 'destination-out';
      down = true;
      lastX = p.x;
      lastY = p.y;
      dot(p.x, p.y);
      check();
    });
    cover.addEventListener('pointermove', function (event) {
      if (!down || !ctx) return;
      var events = event.getCoalescedEvents ? event.getCoalescedEvents() : [event];
      for (var i = 0; i < events.length; i += 1) {
        var p = point(events[i]);
        stroke(lastX, lastY, p.x, p.y);
        lastX = p.x;
        lastY = p.y;
      }
      check();
    });
    var stop = function (event) {
      if (!down) return;
      down = false;
      if (cover.releasePointerCapture) {
        try {
          cover.releasePointerCapture(event.pointerId);
        } catch (e) {
          /* capture already gone */
        }
      }
      if (ctx) ctx.globalCompositeOperation = 'source-over';
    };
    cover.addEventListener('pointerup', stop);
    cover.addEventListener('pointercancel', stop);
  }

  if (card) {
    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        reveal();
        if (claim) claim.focus();
      }
    });
  }

  window.addEventListener('resize', function () {
    if (!root.hidden && wheel && !spinning) paintWheel(lastAngle);
    /* Phones fire resize when the address bar slides away while you scratch. Repainting then wipes the scratches,
       so only repaint when the card really changed width (rotation, desktop window resize). */
    else if (!root.hidden && !revealed && card && card.clientWidth !== size) paintCover();
  });

  /* ---------- wheel: every slice is a prize we can give, the spin picks one by weight ---------- */

  /*
   * Slices come from data-slices (JSON list, one entry per slice, in order), each with a prize `key`; the chance of
   * each prize comes from data-weights (JSON, key to weight). A prize can fill several slices. The won prize key is
   * sent to Klaviyo as profile property `premie`, so the e-mail flow can send the right reward.
   * Only list prizes that can really be won and that Kardima will honour.
   */
  var SLICES = 8;
  var SPIN_MS = 4500;
  var spinning = false;
  var lastAngle = 0;
  var slices = [];
  var weights = {};
  var wonKey = '';
  var startText = subEl ? subEl.textContent : '';
  var wonBig = root.querySelector('[data-ksp-won-big]');
  var wonSmall = root.querySelector('[data-ksp-won-small]');
  var thanksEl = root.querySelector('[data-ksp-thanks]');
  var wonBigDefault = wonBig ? wonBig.textContent : '';
  var thanksDefault = thanksEl ? thanksEl.textContent : '';

  if (wheel) {
    try {
      slices = JSON.parse(wheel.getAttribute('data-slices') || '[]');
      weights = JSON.parse(wheel.getAttribute('data-weights') || '{}');
    } catch (e) {
      slices = [];
    }
    SLICES = slices.length || SLICES;
  }

  function prizeFor(key) {
    for (var i = 0; i < slices.length; i += 1) {
      if (slices[i].key === key) return slices[i];
    }
    return null;
  }

  function paintWheel(angle) {
    if (!wheel || !card || !slices.length) return;
    lastAngle = angle || 0;
    var s = card.clientWidth;
    if (!s) return;
    var r = Math.max(1, window.devicePixelRatio || 1);
    if (wheel.width !== Math.round(s * r)) {
      wheel.width = Math.round(s * r);
      wheel.height = wheel.width;
    }
    var c = wheel.getContext('2d');
    c.setTransform(r, 0, 0, r, 0, 0);
    c.clearRect(0, 0, s, s);

    var css = getComputedStyle(root);
    var emerald = css.getPropertyValue('--kardima-emerald').trim() || '#295442';
    var deep = css.getPropertyValue('--kardima-emerald-deep').trim() || '#1b3b30';
    var gold = css.getPropertyValue('--kardima-gold').trim() || '#c9a65c';
    var ivory = css.getPropertyValue('--kardima-ivory').trim() || '#f7f4ed';
    var warm = css.getPropertyValue('--kardima-ivory-warm').trim() || '#efe9dd';
    var family = getComputedStyle(root.querySelector('.ksp__title')).fontFamily || 'serif';

    var cx = s / 2;
    var rad = s / 2 - 6;
    var arc = (Math.PI * 2) / SLICES;
    c.save();
    c.translate(cx, cx);
    c.rotate(angle || 0);
    for (var i = 0; i < SLICES; i += 1) {
      var sl = slices[i];
      var start = -Math.PI / 2 - arc / 2 + i * arc;
      c.beginPath();
      c.moveTo(0, 0);
      c.arc(0, 0, rad, start, start + arc);
      c.closePath();
      c.fillStyle = i % 2 === 0 ? emerald : warm;
      c.fill();
      c.save();
      c.rotate(start + arc / 2);
      c.fillStyle = i % 2 === 0 ? ivory : deep;
      c.textAlign = 'center';
      c.textBaseline = 'middle';
      /* first line large, second small underneath (across the slice) */
      c.font = '400 ' + Math.round(s * (sl.big.length <= 3 ? 0.085 : 0.06)) + 'px ' + family;
      c.fillText(sl.big, rad * 0.62, sl.small ? -s * 0.03 : 0);
      if (sl.small) {
        c.font = '400 ' + Math.round(s * 0.046) + 'px ' + family;
        c.fillText(sl.small, rad * 0.62, s * 0.048);
      }
      c.restore();
    }
    c.lineWidth = 5;
    c.strokeStyle = gold;
    c.beginPath();
    c.arc(0, 0, rad, 0, Math.PI * 2);
    c.stroke();
    c.restore();

    c.fillStyle = gold;
    c.beginPath();
    c.arc(cx, cx, s * 0.06, 0, Math.PI * 2);
    c.fill();
    c.fillStyle = deep;
    c.beginPath();
    c.arc(cx, cx, s * 0.025, 0, Math.PI * 2);
    c.fill();
  }

  function resetWheel() {
    spinning = false;
    revealed = false;
    wonKey = '';
    lastAngle = 0;
    if (mainBtn) {
      mainBtn.disabled = false;
      mainBtn.textContent = mainBtn.getAttribute('data-spin-label') || 'Snurr hjulet';
      mainBtn.removeAttribute('data-ksp-claim');
      mainBtn.setAttribute('data-ksp-spin', '');
    }
    if (subEl) subEl.textContent = startText;
    if (wonBig) wonBig.textContent = wonBigDefault;
    if (thanksEl) thanksEl.textContent = thanksDefault;
  }

  function wheelDone(index) {
    spinning = false;
    revealed = true;
    var prize = slices[index] || {};
    wonKey = prize.key || '';
    if (mainBtn) {
      mainBtn.disabled = false;
      mainBtn.textContent = mainBtn.getAttribute('data-claim-label') || 'Hent premien';
      mainBtn.removeAttribute('data-ksp-spin');
      mainBtn.setAttribute('data-ksp-claim', '');
    }
    if (subEl && prize.won) subEl.textContent = prize.won;
    if (wonBig && prize.head) wonBig.textContent = prize.head;
    if (thanksEl && prize.thanks) thanksEl.textContent = prize.thanks;
    if (live && prize.won) live.textContent = prize.won;
  }

  /* pick a prize by weight, then one of its slices at random */
  function pickSlice() {
    var keys = {};
    var total = 0;
    var i;
    for (i = 0; i < slices.length; i += 1) {
      var k = slices[i].key;
      if (!keys[k]) {
        keys[k] = Number(weights[k]) || 0;
        total += keys[k];
      }
    }
    var roll = Math.random() * (total || 1);
    var chosen = slices[0].key;
    for (var key in keys) {
      if (Object.prototype.hasOwnProperty.call(keys, key)) {
        if (roll < keys[key]) {
          chosen = key;
          break;
        }
        roll -= keys[key];
      }
    }
    var options = [];
    for (i = 0; i < slices.length; i += 1) {
      if (slices[i].key === chosen) options.push(i);
    }
    return options[Math.floor(Math.random() * options.length)];
  }

  function spin() {
    if (spinning || revealed || !wheel || !slices.length) return;
    spinning = true;
    if (mainBtn) mainBtn.disabled = true;
    var arc = (Math.PI * 2) / SLICES;
    var k = pickSlice();
    var jitter = (Math.random() - 0.5) * 0.5 * arc;
    var target = Math.PI * 2 * 5 - k * arc + jitter;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      paintWheel(target);
      wheelDone(k);
      return;
    }
    var t0 = null;
    function frame(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / SPIN_MS);
      paintWheel(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) window.requestAnimationFrame(frame);
      else wheelDone(k);
    }
    window.requestAnimationFrame(frame);
  }

  /* ---------- clicks, keys ---------- */

  root.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('[data-ksp-spin]')) {
      spin();
      return;
    }
    if (target.closest('[data-ksp-claim]')) {
      showStep('email');
      if (input) input.focus();
      return;
    }
    if (target.closest('[data-ksp-close]')) close(true);
  });

  root.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      close(true);
      return;
    }
    trapFocus(event);
  });

  /* ---------- e-mail ---------- */

  if (form && input && submit && status) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.classList.contains('is-pending')) return;

      var email = (input.value || '').trim();
      if (!EMAIL_PATTERN.test(email)) {
        say('invalid', 'Sjekk e-postadressen.');
        input.focus();
        return;
      }
      if (!preview && (!company || !list)) {
        say('error', 'Noe gikk galt. Prøv igjen, eller skriv til post@kardima.no.');
        return;
      }

      form.classList.add('is-pending');
      submit.disabled = true;
      say('', '');

      var done = function () {
        input.value = '';
        write(STORE_KEY, { done: true });
        showStep('thanks');
      };

      if (preview) {
        window.setTimeout(function () {
          done();
          form.classList.remove('is-pending');
          submit.disabled = false;
        }, 400);
        return;
      }

      var kilde = kildeAttr || 'popup-scratch-' + variant;
      var variantName = kildeAttr ? 'wheel' : variant;
      var props = { kilde: kilde, variant: variantName };
      if (wonKey) props.premie = wonKey;
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: kilde,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email, properties: props }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: list } }
          }
        }
      };

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          /* Klaviyo answers 202 Accepted with an empty body on success. */
          if (response.status === 202 || response.ok) {
            done();
            measure('popup_submit', wonKey ? { premie: wonKey } : null);
            return;
          }
          throw new Error('klaviyo ' + response.status);
        })
        .catch(function () {
          say('error', 'Noe gikk galt. Prøv igjen, eller skriv til post@kardima.no.');
        })
        .then(function () {
          form.classList.remove('is-pending');
          submit.disabled = false;
        });
    });
  }

  /* ---------- when to open ---------- */

  function whenClear(callback) {
    if (!bannerOpen()) {
      callback();
      return;
    }
    var timer = window.setInterval(function () {
      if (!bannerOpen()) {
        window.clearInterval(timer);
        callback();
      }
    }, 500);
  }

  function init() {
    if (window.Shopify && window.Shopify.designMode) return;

    if (/[?&]ksp=[ab]\b/.test(window.location.search) || (/[?&]ksp=show\b/.test(window.location.search) && fixed) || preview) {
      variant = pickVariant();
      open();
      return;
    }

    if (onBlockedPage() || suppressed()) return;

    window.setTimeout(function () {
      whenClear(function () {
        if (suppressed()) return;
        variant = pickVariant();
        open();
      });
    }, delay);
  }

  /* Preview page only: lets the page open a given variant again without reloading. */
  root.addEventListener('ksp:open', function (event) {
    variant = event.detail && event.detail.variant === 'b' ? 'b' : 'a';
    root.hidden = true;
    open();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
